import gql from 'graphql-tag'

export const actions = {
  async LOAD_FILES() {
    try {
      const client = this.app.apolloProvider.defaultClient
      const query = await client.query({
        query: gql`
          query {
            file(sort: { weight: DESC }) {
              entities {
                title
                file {
                  path
                  alt
                }
              }
            }
          }
        `,
      })
      return query.data.file.entities
    } catch (e) {
      console.error(e)
    }
  },
}
